const IMAGE_EXTENSION_PATTERN = /\.(avif|bmp|gif|heic|heif|jpe?g|png|svg|webp)$/i;
const HEIC_MIME_TYPES = new Set([
    'image/heic',
    'image/heic-sequence',
    'image/heif',
    'image/heif-sequence',
]);

export const isSupportedImageFile = (file?: File | null) => {
    if (!file) return false;

    const fileType = (file.type || '').toLowerCase();
    if (fileType.startsWith('image/')) {
        return true;
    }

    if (HEIC_MIME_TYPES.has(fileType)) {
        return true;
    }

    return IMAGE_EXTENSION_PATTERN.test(file.name || '');
};
